import { Avatar, Typography } from '@mui/material'
import './TDTabs.scss'

const TDTabs = ({ tabs, currentTab, onClick }) => {
  return (
    <div className='td-link-tabs__container'>
      {tabs.map((tab, index) => (
        <div
          key={tab.key}
          className={`td-link-tabs__link ${
            currentTab === tab.key ? 'td-link-tabs__link--active' : ''
          }`}
          onClick={() => {
            onClick(tab)
          }}
        >
          <Avatar
            sx={{ width: 24, height: 24, fontSize: 14 }}
            className='td-link-tabs__link__avatar'
          >
            {index + 1}
          </Avatar>
          <Typography variant='h5' fontWeight={500}>
            {tab.name}
          </Typography>
        </div>
      ))}
    </div>
  )
}

export default TDTabs
